import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class BusinessTypeService {
    constructor(private http: HttpClient) {}

    async getListBusinessTypes(
        startIndex: number,
        fetchRecord: number,
        searchTerm: string,
        token?: string
    ): Promise<any> {
        const parameter = {
            startIndex,
            fetchRecord,
            searchString: searchTerm || null,
            typeId: null, // Not used in this implementation
        };

        return await firstValueFrom(
            this.http.post(
                environment.apiUrl +
                    '/api/v0.4.0/saasBusinessTypes/businessTypeGetList',
                parameter
            )
        );
    }

    async checkBusinessTypeNameExists(
        typeName: string,
        typeId: number | undefined,
        token?: string
    ): Promise<any> {
        const parameter = {
            typeName,
            typeId,
        };

        return await firstValueFrom(
            this.http.post(
                environment.apiUrl +
                    '/api/v0.4.0/saasBusinessTypes/businessTypeCheckNameExist',
                parameter
            )
        );
    }

    async businessTypeInsert(type: any, token?: string): Promise<any> {
        const parameter = {
            type: {
                name: type.name,
                displayOrder: type.displayOrder,
                isActive: true,
                isDelete: false,
            },
        };

        return await firstValueFrom(
            this.http.post(
                environment.apiUrl +
                    '/api/v0.4.0/saasBusinessTypes/businessTypeInsert',
                parameter
            )
        );
    }

    async businessTypeUpdate(type: any, token?: string): Promise<any> {
        const parameter = {
            type: {
                id: type.id,
                name: type.name,
                displayOrder: type.displayOrder,
                isActive: type.isActive,
                isDelete: type.isDelete,
            },
        };

        return await firstValueFrom(
            this.http.post(
                environment.apiUrl +
                    '/api/v0.4.0/saasBusinessTypes/businessTypeUpdate',
                parameter
            )
        );
    }

    async businessTypeDelete(typeId: number, token?: string): Promise<any> {
        const parameter = {
            id: typeId,
        };

        return await firstValueFrom(
            this.http.post(
                environment.apiUrl +
                    '/api/v0.4.0/saasBusinessTypes/businessTypeDelete',
                parameter
            )
        );
    }
}
